import { Badge, Text } from '@chakra-ui/react';
import { ValidateItemCodeResponse } from '@texas/api/endpoints/articlesApi';
import { Icons } from '@texas/components/shared/Icons';
import { createArticleStyles as styles } from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';

export function ItemCodeAvailabilityStatus({
  loading,
  validationFailed,
  result,
}: {
  loading: boolean;
  validationFailed: boolean;
  result?: ValidateItemCodeResponse;
}) {
  const { t } = useTranslation();

  if (validationFailed) return <>{t('article.copy.validationFailed')}</>;

  if (loading) return <>{t('article.create.checking')}</>;

  if (result?.isValid)
    return (
      <Badge variant="entity-status-active" sx={styles.availableStatus}>
        <Icons.Checkmark aria-hidden={true} />
        {t('article.create.available')}
      </Badge>
    );

  if (
    result?.errorType === 'InUseByTexas' ||
    result?.errorType === 'ArchivedInTexas'
  )
    return (
      <Badge
        colorScheme="red"
        sx={styles.availableStatus}
        whiteSpace="normal"
        maxW="100%"
      >
        <Icons.AlertCircle aria-hidden={true} flexShrink={0} />
        <Text as="span" minW={0}>
          {result.errorMessage}
        </Text>
      </Badge>
    );

  return <>{result?.errorMessage ?? t('article.create.checking')}</>;
}
